import { useTranslation } from 'react-i18next';
import { useContext } from 'react';

import { Box, Flex, FormContext, Text } from 'dash-ui';
import styled, { useTheme } from 'styled-components';

const PointerWrapper = styled(Box)`
  cursor: pointer;
`;

const MortgageHeader = () => {
  const { t } = useTranslation(['forms', 'common']);
  const { resetFormErrors, resetForm } = useContext(FormContext);
  const theme = useTheme();

  const onClear = () => {
    resetForm();
    resetFormErrors();
  };

  return (
    <Flex w="100%" flex={1} justifyContent="space-between" alignItems="center">
      <Flex flex={2}>
        <Text semibold lg>
          {t('pages:dashboardPage.mortgageWidget.mortgageModalTitle')}
        </Text>
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        <PointerWrapper onClick={onClear}>
          <Text color={theme.colors.b50}>{t('common:labels.clear')}</Text>
        </PointerWrapper>
      </Flex>
    </Flex>
  );
};

export default MortgageHeader;
